/**
 * Export components
 */
export { default as IconTab } from './icon-tab';
export { default as OverlayTab } from './overlay-tab';
export { default as TextTab } from './text-tab';
export { default as InfotipIcon } from './icon';

